import React, { useCallback } from "react"

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@coval/ui"

import type {
  TraceStatusFilterConfig,
  TraceStatusValue,
} from "@/types/metrics/metadata"

import { TRACE_STATUS_VALUES } from "../types"

interface StatusFilterEditorProps {
  filter: TraceStatusFilterConfig
  onChange: (filter: TraceStatusFilterConfig) => void
}

export const StatusFilterEditor: React.FC<StatusFilterEditorProps> = ({
  filter,
  onChange,
}) => {
  const handleValueChange = useCallback(
    (value: string) => {
      onChange({ ...filter, value: value as TraceStatusValue })
    },
    [filter, onChange],
  )

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-coval-text-muted">status is</span>
      <Select value={filter.value} onValueChange={handleValueChange}>
        <SelectTrigger className="w-32" aria-label="Trace status value">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {TRACE_STATUS_VALUES.map((status) => (
            <SelectItem key={status.value} value={status.value}>
              {status.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
